/**
 * kp-lenis — smooth scroll for the whole document.
 *
 * Lenis (kp-vendor-lenis.min.js, v1.3.26) drives the NATIVE window scroll,
 * so everything Dawn does with scroll events — the sticky header, scroll
 * reveals, the sticky add-to-cart — keeps working untouched. The theme owns
 * only the decisions below:
 *
 * 1. WHEN NOT TO RUN. Not in the theme editor (the editor scrolls sections
 *    into view and Lenis would fight it), not under reduced motion (Lenis
 *    would go 1:1 anyway; skipping saves the work), and not on touch — Lenis
 *    leaves touch scrolling native by default, so on a phone it would be
 *    18 KB doing nothing. `(hover: none)` is the touch test; the old theme
 *    used width < 768, which misses touch laptops and catches small windows.
 *
 * 2. DRAWERS. Dawn locks the page by putting `overflow-hidden` (or
 *    `overflow-hidden-<breakpoint>`) on <body> when the cart drawer, menu
 *    drawer or search modal is open. Lenis must stop while that class is
 *    there — otherwise a wheel over the scrim still nudges the page — and
 *    start again when it goes. One MutationObserver on body.class is the
 *    whole bridge; Dawn's own code is never patched.
 *
 * 3. NESTED SCROLL. `allowNestedScroll` makes Lenis hand the wheel to any
 *    element that can scroll itself (drawer bodies, the mega-menu, the
 *    predictive search panel) with no `data-lenis-prevent` sprinkled around.
 *
 * `anchors` stays off: the skip-to-content link relies on the browser
 * moving focus with the hash, which Lenis's anchor handling suppresses.
 *
 * The instance is published as window.__lenis for kp-back-to-top.js.
 */
(function () {
  if (window.__lenis || typeof window.Lenis !== 'function') return;

  var root = document.documentElement;
  if (root.classList.contains('shopify-design-mode')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;

  var lenis = new window.Lenis({
    autoRaf: true,
    duration: 1,
    smoothWheel: true,
    wheelMultiplier: 1,
    allowNestedScroll: true,
    anchors: false,
  });
  window.__lenis = lenis;

  var LOCK = /(^|\s)overflow-hidden(-\w+)?(\s|$)/;
  var locked = false;

  function syncLock() {
    var now = LOCK.test(document.body.className);
    if (now === locked) return;
    locked = now;
    if (locked) lenis.stop();
    else lenis.start();
  }

  new MutationObserver(syncLock).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  syncLock();

  // The editor can be entered without a reload (preview → customize); the
  // class flips, and so should we.
  new MutationObserver(function () {
    if (root.classList.contains('shopify-design-mode')) {
      lenis.destroy();
      window.__lenis = null;
    }
  }).observe(root, { attributes: true, attributeFilter: ['class'] });
})();
